import Vue from "vue";
import Vuetify from "vuetify/lib";
import "@/assets/stylus/main.styl";

Vue.use(Vuetify);

console.log("Vue.js version " + Vue.version);
console.log("Vuetify version " + Vuetify.version);
